import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';

import { getContext, storeToken } from './web-notification-service-ctx';
import { handleMessage, rePairDevice } from './web-notification';

const { apiKey, appId, messagingSenderId, projectId, vapidKey } = window.FIREBASE_CONFIG;
let messaging;

export function initFirebaseMessaging(serviceWorkerRegistration) {
    if (!messaging) {
        messaging = getMessaging(initializeApp({ apiKey, appId, messagingSenderId, projectId }));
    }
    if (Notification.permission === 'granted') {
        onMessage(messaging, handleMessage);
        return loadToken(serviceWorkerRegistration)
            .then(storeToken)
            .then(checkUserChange)
            .catch(e => console.error('Cannot get messaging token', e));
    }
}

function loadToken(serviceWorkerRegistration) {
    const { token } = getContext();
    return token ? Promise.resolve(token) : getToken(messaging, { vapidKey, serviceWorkerRegistration });
}

// presunute, ale docielime tym, ze messaging je len v scope tohto filu
export function reqNotifyPermThenSync() {
    return Notification.requestPermission().then(permission => {
        if (permission === 'granted' && 'serviceWorker' in navigator) {
            return navigator.serviceWorker.getRegistration().then(initFirebaseMessaging);
        }
    });
}

// otestujeme ci prihlaseny pouzivatel je rovnaky ako v localstorage, ak nie, stareho odregistrujeme
function checkUserChange(token) {
    const { cisloZmluvy } = window.USER_DATA_SNAPSHOT;
    const { contractId } = getContext();

    // ak user nie je prihlaseny alebo nie je subscribnuty na notifikacie => nerobime nic
    if (!cisloZmluvy || !contractId) {
        return token;
    }
    // ak je prihlaseny iny user ako subscribnuty, re-pair.
    if (cisloZmluvy !== contractId) {
        rePairDevice();
    }
    return token;
}
